var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.menu == "home.dashboardDataBoard" ? _c("div", {
    staticClass: "btns",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticClass: "btn",
    class: _vm.type == "POLICY_PREMIUM" ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.callback("POLICY_PREMIUM", true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保单保费")) + " ")]), _c("div", {
    staticClass: "btn",
    class: _vm.type == "CLAIMS" ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.callback("CLAIMS", true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("理赔数据")) + " ")]), _c("div", {
    staticClass: "btn",
    class: _vm.type == "ACHIEVEMENT" ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.callback("ACHIEVEMENT", true);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("业绩分析")) + " ")])]) : _vm._e(), _vm.menu == "customer.dashboardDataBoard" ? _c("a-tabs", {
    attrs: {
      activeKey: _vm.type
    },
    on: {
      change: _vm.callback
    }
  }, [_c("a-tab-pane", {
    key: "POLICY_PREMIUM",
    attrs: {
      tab: _vm.$t("保单保费")
    }
  }), _c("a-tab-pane", {
    key: "CLAIMS",
    attrs: {
      tab: _vm.$t("理赔数据")
    }
  }), _c("a-tab-pane", {
    key: "ACHIEVEMENT",
    attrs: {
      tab: _vm.$t("业绩分析")
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "tiimeBox"
  }, [_c("div", {
    staticClass: "name"
  }, [_c("span", [_vm._v("* ")]), _vm._v(_vm._s(_vm.$t("时间筛选方式：")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-radio-group", {
    attrs: {
      name: "radioGroup"
    },
    on: {
      change: function ($event) {
        return _vm.callback(_vm.type);
      }
    },
    model: {
      value: _vm.queryMethod,
      callback: function ($$v) {
        _vm.queryMethod = $$v;
      },
      expression: "queryMethod"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "WHOLE"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("整体页面查询")) + " ")]), _c("a-radio", {
    attrs: {
      value: "SINGLE"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("每个面板独立查询")) + " ")])], 1), _c("div", {
    staticClass: "timeFrame"
  }, [_vm._v(" " + _vm._s(_vm.$t("默认展示")) + " "), _c("a-select", {
    staticStyle: {
      width: "190px"
    },
    on: {
      change: function ($event) {
        return _vm.callback(_vm.type);
      }
    },
    model: {
      value: _vm.timeFrame,
      callback: function ($$v) {
        _vm.timeFrame = $$v;
      },
      expression: "timeFrame"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "MONTH"
    }
  }, [_vm._v(_vm._s(_vm.$t("本月")))]), _c("a-select-option", {
    attrs: {
      value: "MARCH"
    }
  }, [_vm._v(_vm._s(_vm.$t("近三月")))]), _c("a-select-option", {
    attrs: {
      value: "WEEK"
    }
  }, [_vm._v(_vm._s(_vm.$t("本周")))]), _c("a-select-option", {
    attrs: {
      value: "YEAR"
    }
  }, [_vm._v(_vm._s(_vm.$t("本年")))])], 1), _vm._v(" " + _vm._s(_vm.$t("的数据")) + " ")], 1)], 1)]), _vm.customShow ? _c("custom", {
    key: _vm.timer1,
    ref: "customRef",
    attrs: {
      menu: _vm.menu,
      queryMethod: _vm.queryMethod,
      timeFrame: _vm.timeFrame,
      type: _vm.type,
      customerId: Number(_vm.id),
      bulletinBoardList: _vm.bulletinBoardList
    },
    on: {
      ok: function ($event) {
        return _vm.$emit("ok");
      },
      setInfo: _vm.setInfoFun,
      back: function ($event) {
        return _vm.$emit("back");
      },
      setItem: _vm.callback,
      delArr: _vm.delArrFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };